module.exports = __webpack_public_path__ + "assets/img/banner8.3c91d5b3.png";